import React, { useEffect } from 'react';
import { Editor, EditorState, Modifier, RichUtils, SelectionState } from 'draft-js';
import './DraftEditor.scss';
import colors from './colorDefinitins';


const colorStyleMap ={};
(function createColors() {
  colors.forEach(color => {
    const key = Object.keys(color)[0]
    colorStyleMap[key] = { color: color[key] };
  });
})();

const INLINE = 'INLINE';
const BLOCK  = 'BLOCK';
const COLOR  = 'COLOR';

function DraftEditor (props) {
  const { editorState, setEditorState } = props;
  const currentStyle = editorState.getCurrentInlineStyle();
  let editorRef;
  const setEditorRef = ref => editorRef = ref;

  useEffect(() => {
    const { type, style } = props.styleChange;
    switch(type) {
      case INLINE:
        inlineStyleChange(style);
        break;
      case BLOCK:
        blockStyleChange(style);
        break;
      case COLOR:
        changeColor(style);
        break;
      default:
        break;
    }
    // eslint-disable-next-line
  }, [props.styleChange]);

  const onChange = (editorState) => {
    props.action();
    return setEditorState(editorState);
  }

  const moveSelectionToEnd = editorState => {
    const content = editorState.getCurrentContent();
    const blockMap = content.getBlockMap();
  
    const key = blockMap.last().getKey();
    const length = blockMap.last().getLength();
    const selection = new SelectionState({
      anchorKey: key,
      anchorOffset: length,
      focusKey: key,
      focusOffset: length,
    });
    return EditorState.forceSelection(editorState, selection);
  };

  
  // Styles like Bold, Italics ...
  const inlineStyleChange = (style) => {
    onChange(RichUtils.toggleInlineStyle(editorState, style));
  }

  // Styles like headers, paragrafs, ul, li ...
  const blockStyleChange = (style) => {
    onChange(RichUtils.toggleBlockType(editorState, style));
  }

  // Changes color of inline element
  const changeColor = (toggledColor) => {
    const selection = editorState.getSelection();

    // Let's just allow one color at a time. Turn off all active colors.
    const nextContentState = Object.keys(colorStyleMap)
      .reduce((contentState, color) => {
        return Modifier.removeInlineStyle(contentState, selection, color)
      }, editorState.getCurrentContent());

    let nextEditorState = EditorState.push(
      editorState,
      nextContentState,
      'change-inline-style'
    );

    // Unset style override for current color.
    if (selection.isCollapsed()) {
      nextEditorState = currentStyle.reduce((state, color) => {
        return RichUtils.toggleInlineStyle(state, color);
      }, nextEditorState);
    }

    // If the color is being toggled on, apply it.
    if (!currentStyle.has(toggledColor)) {
      nextEditorState = RichUtils.toggleInlineStyle(
        nextEditorState,
        toggledColor
      );
    }

    onChange(nextEditorState);
  }

  const focus = () => {
    editorRef.focus();
    setEditorState(moveSelectionToEnd(editorState));
  }

  return (
    <div onClick={ev => {focus()}} className="DraftEditor-wrap">
      <div onClick={ev => ev.stopPropagation()}>
        <Editor
          editorState={editorState}
          customStyleMap={colorStyleMap}
          onChange={onChange}
          ref={setEditorRef}
        />
      </div>
    </div>
  );
}

export default DraftEditor;
